import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import EmployeesService from "../../../../../services/HRM/EmployeesService";
import { Translate } from "../../../../Enums/Tranlate";
import DeductionService from "../../../../../services/HRM/DeductionService";

const AddDeductionModal = ({ modal, setModal, item, setShouldUpdate }) => {
	const [formData, setFormData] = useState({
		employee: "",
		deduction: "",
		month: "",
		type: "",
	});
	const types = [
		{ label: "Money", value: "money" },
		{ label: "Days", value: "days" },
	];
	const [monthOptions, setMonthOptions] = useState([]);
	const [yearOptions, setYearOptions] = useState([]);
	const [employeesOptions, setEmployeesOptions] = useState([]);
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const deductionService = new DeductionService();
	const employeesService = new EmployeesService();
	const lang = useSelector((state) => state.auth.lang);

	useEffect(() => {
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			let date = new Date(item?.month);
			const month = date.toLocaleString("default", { month: "long" });
			const year = date.getFullYear();

			setFormData({
				id: item?.id,
				type:
					types.find((res) => res.value?.toLocaleUpperCase() === item.type) ||
					"",
				employee: {
					label: item?.employee.name,
					value: item?.employee.id,
				},
				month: {
					label: Translate[lang][month.toLocaleLowerCase()],
					value: month,
				},
				year: {
					label: year,
					value: year,
				},
				deduction: item?.type === "MONEY" ? item.amount : item.days,
			});
		}
	}, [item]);

	const months = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	];
	useEffect(() => {
		const today = new Date();
		const currentMonth = today.getMonth();
		const remainingMonths = months.slice(currentMonth)?.map((res) => {
			return {
				label: Translate[lang][res.toLocaleLowerCase()],
				value: res,
			};
		});

		setMonthOptions([...remainingMonths]);
	}, [lang]);

	useEffect(() => {
		const currentYear = new Date().getFullYear();
		const yearOptions = [];
		for (let i = currentYear; i <= currentYear + 5; i++) {
			yearOptions.push({
				label: `${i}`,
				value: i,
			});
		}
		setYearOptions(yearOptions);
	}, []);

	useEffect(() => {
		employeesService?.getList({ page: 1, limit: 100 }).then((res) => {
			if (res?.status === 200) {
				let data = res?.data?.data?.data?.map((emp) => {
					return {
						...emp,
						label: emp?.name,
						value: emp.id,
					};
				});
				setEmployeesOptions(data);
			}
		});
	}, []);

	const submit = (e) => {
		e.preventDefault();
		const monthNumber = months.indexOf(formData?.month?.value) + 1;
		const monthFormatted = `${formData?.year?.value}-${String(monthNumber).padStart(2, "0")}-01`;
		let data = {
			employeeId: formData?.employee?.value,
			month: monthFormatted,
			type: formData?.type?.value?.toLocaleUpperCase(),
		};
		data[formData?.type?.value === "money" ? "amount" : "days"] =
			formData?.deduction;

		if (formData?.type?.value !== "money") {
			data.amount = null;
		}
		setLoading(true);
		if (isAdd) {
			deductionService.create(data)?.then((res) => {
				if (res && res?.status === 201) {
					toast.success("Deduction Added Successfully");
					setShouldUpdate((prev) => !prev);
					setModal();
				}
				setLoading(false);
			});
		} else {
			deductionService.update(formData?.id, data)?.then((res) => {
				if (res && res?.status === 200) {
					toast.success("Deduction Updated Successfully");
					setShouldUpdate((prev) => !prev);
					setModal();
				}
				setLoading(false);
			});
		}
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addProduct" : "ar fade addProduct"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={modal}
			onHide={() => {
				setModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Header>
					<Modal.Title>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.deduction}
					</Modal.Title>
					<Button
						variant=""
						className="close"
						style={{
							right: lang === "en" ? "0" : "auto",
							left: lang === "ar" ? "0" : "auto",
						}}
						onClick={() => {
							setModal();
						}}>
						<span>&times;</span>
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col md={6} className="mb-3">
							<label className="text-label">{Translate[lang].employee}</label>
							<Select
								placeholder={Translate[lang]?.select}
								options={isAdd ? employeesOptions : []}
								value={formData.employee}
								onChange={(e) => setFormData({ ...formData, employee: e })}
							/>
						</Col>
						<Col md={6} className="mb-3">
							<label className="text-label">{Translate[lang].type}</label>
							<Select
								placeholder={Translate[lang]?.select}
								options={types}
								value={formData.type}
								onChange={(e) => setFormData({ ...formData, type: e })}
							/>
						</Col>
						{!!formData?.type && (
							<Col md={6}>
								<AvField
									label={`${
										formData?.type?.value === "money"
											? `${Translate[lang]?.deduction} (KWD)`
											: "Days"
									}`}
									placeholder={`${
										formData?.type?.value === "money"
											? `${Translate[lang]?.deduction}`
											: "Days"
									}`}
									type="text"
									bsSize="lg"
									name="deduction"
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.deduction}
									onChange={(e) =>
										setFormData({ ...formData, deduction: e.target.value })
									}
								/>
							</Col>
						)}

						<Col md={3}>
							<label className="text-label">{Translate[lang].month}</label>
							<Select
								placeholder={Translate[lang]?.select}
								options={monthOptions}
								value={formData.month}
								onChange={(e) => setFormData({ ...formData, month: e })}
							/>
						</Col>
						<Col md={3}>
							<label className="text-label">{Translate[lang].year}</label>
							<Select
								placeholder={Translate[lang]?.select}
								options={yearOptions}
								value={formData.year}
								onChange={(e) => setFormData({ ...formData, year: e })}
							/>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={setModal} variant="danger light">
						{Translate[lang]?.close}
					</Button>
					<Button variant="primary" type="submit" disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddDeductionModal;
